import { useQuery } from '@tanstack/react-query';

import { listCustomers } from '../crm/api';
import { listTickets } from '../tickets/api';

/**
 * Die Suchen der Befehlspalette.
 *
 * Eigene Abfragen und keine Wiederverwendung von ``useTicketList``: Die Liste
 * blaettert ueber einen Cursor, haelt ihre Seiten im Zwischenspeicher und ist
 * immer aktiv. Die Palette braucht das Gegenteil -- die besten fuenf, nur
 * solange etwas im Feld steht, und nach dem Schliessen vergessen.
 *
 * **Gefragt wird ab zwei Zeichen.** Ein einzelner Buchstabe trifft in einem
 * Ticketbestand alles und kostet den Server eine Abfrage ueber den ganzen
 * Index -- fuer eine Trefferliste, die niemandem hilft.
 */

/** Ab wie vielen Zeichen gefragt wird. */
export const MIN_SEARCH_LENGTH = 2;

/** So viele Treffer je Bereich. Mehr passt nicht in die Palette, ohne dass
 *  man blaettert -- und wer blaettert, haette die Liste aufgemacht. */
const LIMIT = 5;

export function useTicketSearch(term: string) {
  const enabled = term.length >= MIN_SEARCH_LENGTH;

  return useQuery({
    queryKey: ['palette', 'tickets', term],
    queryFn: () => listTickets({ q: term, limit: LIMIT }),
    enabled,
    // Fuenf Sekunden: lang genug, dass ein Tippfehler und die Korrektur
    // danach nicht zwei Abfragen sind, kurz genug, dass ein frisch
    // angelegtes Ticket gefunden wird.
    staleTime: 5_000,
    retry: false,
  });
}

export function useCustomerSearch(term: string) {
  const enabled = term.length >= MIN_SEARCH_LENGTH;

  return useQuery({
    queryKey: ['palette', 'customers', term],
    queryFn: () => listCustomers({ q: term, limit: LIMIT }),
    enabled,
    staleTime: 5_000,
    retry: false,
  });
}
